module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-001"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("GOD TELLS HOSEA TO MARRY A HARLOT"), _c('br'), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Hosea+1%3A1-3&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("HOSEA 1:1-3")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" God often calls the prophets to undertake a difficult path in calling people to repentance (I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SHO‘DAD")]), _vm._v("). The union between Christ and the church is symbolized by the relation between Hosea and Gomer (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME,")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENAEUS")]), _vm._v("). The unusual choice for Hosea’s wife highlights the para"), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("dox of divine election and condescension (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEO-DORE")]), _vm._v("). Hosea’s marriage is God’s symbolic charge against Israel. It accuses them of lawlessness and impiety (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET")]), _vm._v("). Sensual people pursue false teaching as one would a prostitute. The prostitute Gomer prefigured the prostitute who washed Jesus’ feet (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(").")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-028"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("1:1-3 "), _c('i', [_vm._v("Hosea Marries Gomer")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('b', [_vm._v("A W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOREDOM.")])]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SHO‘DAD OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERV")]), _vm._v(": “Take for yourself a wife who gives herself over to whoredom.” God does not say “a whore” but “who gives herself over to whoredom,” that is, consorts with men and idols. Note the words “children who give themselves over to whoredom.” How could they give themselves to whoredom if they were not yet born? But this means that when she has children, they too will give themselves over to whoredom in body and mind just like her. The Hebrew text says “children of harlotry.” We may wonder how people knew that the prophet, by taking a woman of whoredom, was doing something different from what he seemed to be doing, since he had not made any revelation to the people yet. It is probable that the prophet himself, after taking the woman, explained to the people the reason why he had taken her. . . . It may be that the people understood this situation because the prophet had so far kept himself in a state of chastity. . . . God represented through the woman of whoredom the community of the ten tribes who openly practiced the worship of idols. They are like the woman of whoredom who prostitutes herself by leaving her room open—at the time of Jeroboam. They are like those of the house of Judah who through the adulterous woman publicly swore to God but secretly worshiped the idol Milkom.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN6",
      "id": "ap_NFIN6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" In fact Gomer was famous for her whoredom, like the Egyptians Oholah and Oholibah."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN7",
      "id": "ap_NFIN7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" God may order the prophet to do what is unsuitable and inconvenient, as he ordered Isaiah to walk naked and barefoot"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN8",
      "id": "ap_NFIN8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" and Ezekiel to bake bread on human excrement."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN9",
      "id": "ap_NFIN9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" In fact, it was typical for the hard and stubborn heart of the people of Israel to despise actively the words before their eyes, which showed the afflictions coming their way. And so, if God punishes the holy prophets because of the people, he will punish even more the people themselves, in order that, after being confronted with the outrage of these terrifying actions, they may be frightened and turn away from their crimes. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN10",
      "id": "ap_NFIN10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TS")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRUGGLES.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": If you merely regard the narrative, the words are simple enough, but if you look beneath the surface at the hidden meaning of it, you find a description of the small numbers of the church and of the wars the heretics wage against it. The twelve prophets, whose writings are compressed within the narrow limits of a single volume, have typical meanings far from their literal ones. Hosea speaks many times of Ephraim, of Samaria, of Joseph, of Jezreel, of a wife of whoredoms and of children of whoredoms, of an adulterous woman shut up within the chamber of her husband, sitting for a long time in the widowhood and in the garb of mourning, awaiting the time when her husband will return to her. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER 53.7.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN11",
      "id": "ap_NFIN11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANCTIFIES THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH.")])]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENAEUS")]), _vm._v(": From these [unlikely] people God will build the church, which will be made holy through its union with the Son of God, as this woman was made holy by her union with the prophet. Paul says that the unbelieving wife is made holy by her believing husband."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN12",
      "id": "ap_NFIN12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GAINST")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERESIES 4.20.12.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN13",
      "id": "ap_NFIN13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROM")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOREDOM TO")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRTUE.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": We should not blame the prophet if he converted a prostitute to virtue, but we should rather praise him because he turned a bad woman into a good one. . . . Hence we understand that it was not the prophet who lost virtue by joining with a prosti"), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("tute, but rather the latter gained virtue that she never had before. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN14",
      "id": "ap_NFIN14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARADOX OF")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVINE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONDESCENSION.")])]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA")]), _vm._v(": By the law the prophet was allowed to take a woman into the marriage relationship, and on marrying her he probably brought her to chaste ways. In fact, while everyone could not but be surprised that a man who was very conscious of propriety should pass over women who enjoyed a good reputation and choose to take a prostitute into the marriage relationship, the novelty of the event provided the prophet with the occasion of telling them their duty. In addition [Hosea’s marriage demonstrated] the greater marvel of God’s condescending to choose such ungrateful people for special attention by the powerful example—namely, the remarkable prophet’s doing his duty by entering into association with a prostitute. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 1.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN15",
      "id": "ap_NFIN15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARGE OF")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MPIETY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GAINST")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SRAEL.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR")]), _vm._v(": Likewise the Lord of all had bade Hosea also, therefore, marry a loose woman so as by the event to charge the people with impiety and give evidence of his characteristic longsuffering. If the God of all put up with the loose and adulterous synagogue, however, and the fount of holiness was not defiled by that loathsome and abominable thing, neither did the prophet incur any defilement from that licentious woman. Without being in thrall to lust, and instead carrying out a command from on high, he put up with that awful relationship. Now one must realize how judgment is made between good and bad by the purpose involved: on that basis marriage is distinguished from adultery, and though intercourse involves no difference, the difference emerges in the purpose and the law, and on the same basis what is lawful is distinguished from what is lawless. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 1.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN16",
      "id": "ap_NFIN16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CENE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFIGURES THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSTITUTE WITH")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": Under no circumstances would any reasonable person imagine that the Lord’s feet were anointed with precious ointment by the woman"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN17",
      "id": "ap_NFIN17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" for the same reason that was customary for sensual, dissolute men whose banquets were such that we loathe them. In that case the good odor"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN18",
      "id": "ap_NFIN18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" is the good reputation that each one will possess by the works of good life, as long as one follows the footsteps of Christ, and as it were, anoints his feet with very precious ointment. Hence what is frequently sinful in other persons is a symbol of some sublime truth in the person of God or a prophet. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N-STRUCTION 12.18.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN19",
      "id": "ap_NFIN19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa1e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap2.vue
// module id = 84
// module chunks = 0